import DisplayCustomReportColumn from '../../../../../components/specific/reports-custom/DisplayCustomReportColumn'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'

const TemplateDetails = ({ columns, reportId }) => {
  return (
    <Box sx={{ maxHeight: '99%', maxWidth: '99%', overflow: 'auto' }}>
      <Stack direction='row' spacing={1} alignItems='center'>
        {columns?.map((column) => {
          return <DisplayCustomReportColumn colData={column} />
        })}
      </Stack>
      <Button
        href={`/reports-custom/editing/details/${reportId}`}
        disableElevation
        size='small'
        variant='outlined'
        sx={{ fontSize: 14, textTransform: 'none', marginTop: '10px' }}
      >
        Edit
      </Button>
    </Box>
  )
}

export default TemplateDetails
